import ChatPageSvg from "../svg/ChatPageSvg";
import CoursesPageSvg from "../svg/CoursesPageSvg";
import HomePageSvg from "../svg/HomePageSvg";
import NavigationSvg from "../svg/NavigationSvg";
import SearchPageSvg from "../svg/SearchPageSvg";

export const tabsPagesConst = {
  tabs: [
    {
      id: "Home",
      link: "/",
      img: HomePageSvg,
      text: "Главная",
    },
    {
      id: "Programs",
      link: "/programs",
      img: CoursesPageSvg,
      text: "Программы",
    },
    {
      id: "Search",
      link: "/search",
      img: SearchPageSvg,
      text: "Поиск",
    },
    {
      id: "Contact",
      link: "/contact",
      img: ChatPageSvg,
      text: "Контакты",
    },
  ],
  navigation: {
    link: "/navigation",
    img: NavigationSvg,
  },
};
